// const rotationInterval = 4000; // Rotate every 4 seconds
// const transitionDuration = 750; // Match CSS transition
// const grid = document.querySelector('.block-media-masonry__grid');

// function getRotationCount() {
// 	return window.innerWidth <= 768 ? 6 : 9;
// }

// function rotateImages() {
// 	const figures = Array.from(grid.querySelectorAll('figure'));
// 	const count = getRotationCount(); // Get the correct number of items to rotate

// 	// Get the current set (either first 9 or first 6)
// 	const currentSet = figures.slice(0, count);

// 	// Get the next set (either next 9 or next 6)
// 	const nextSet = figures.slice(count, count * 2);

// 	// Make the next set positioned ABOVE the current set (so it's already in place)
// 	nextSet.forEach((figure) => {
// 		figure.style.transform = 'translateY(-100%)';
// 		figure.style.opacity = '1';
// 	});

// 	// Animate current set downwards and fade out
// 	currentSet.forEach((figure) => {
// 		figure.classList.add('slide-out');
// 	});

// 	// Animate next set into view
// 	setTimeout(() => {
// 		nextSet.forEach((figure) => {
// 			figure.classList.add('slide-in');
// 		});
// 	}, 10); // Small delay ensures animations fire correctly

// 	// Wait for the animation to complete, then reset positions
// 	setTimeout(() => {
// 		currentSet.forEach((figure) => {
// 			figure.classList.remove('slide-out');
// 			figure.style.transform = 'translateY(0)'; // Reset position
// 			grid.appendChild(figure); // Move them to the end AFTER animation finishes
// 		});

// 		nextSet.forEach((figure) => {
// 			figure.classList.remove('slide-in');
// 			figure.style.transform = 'translateY(0)'; // Reset position after entering
// 		});
// 	}, transitionDuration);
// }

// // Start rotation
// setInterval(rotateImages, rotationInterval);
const rotationInterval = 4000; // Rotate every 4 seconds
const transitionDuration = 750; // Match CSS transition
const grid = document.querySelector('.block-media-masonry__grid');

function toggleImages() {
	const figures = grid.querySelectorAll('figure');

	figures.forEach((figure) => {
		const imgWrapper = figure.querySelector('.wp-block-image__wrapper');
		const img = imgWrapper?.querySelector('img');

		if (!img) return; // Skip if no image

		const alternateSrc = imgWrapper.getAttribute('data-info');

		if (!alternateSrc) return; // Skip if no data-info attribute

		// Preload the alternate image before swapping
		const tempImg = new Image();
		tempImg.src = alternateSrc;
		tempImg.onload = () => {
			// Start fade-out transition
			img.style.transition = `opacity ${transitionDuration}ms ease-out, transform ${transitionDuration}ms ease-out`;
			img.style.opacity = '0';
			img.style.transform = 'translateY(10px)';

			// After transition, swap images
			setTimeout(() => {
				const currentSrc = img.getAttribute('src');
				img.setAttribute('src', alternateSrc);
				img.removeAttribute('srcset'); // Remove srcset to prevent override
				imgWrapper.setAttribute('data-info', currentSrc); // Swap src and data-info

				// Fade back in
				img.style.opacity = '1';
				img.style.transform = 'translateY(0)';
			}, transitionDuration);
		};
	});
}

// Start rotation
setInterval(toggleImages, rotationInterval);
